import { render } from "./RailsForm.vue?vue&type=template&id=9f0ab95e"
import script from "./RailsForm.vue?vue&type=script&lang=js"
export * from "./RailsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__